import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Image } from "../../entity/Image";
import { AbstractCRUDService } from "./AbstractCRUDService";

@Injectable()
export class ImageService extends AbstractCRUDService<Image, string> {

	private constructor(httpClient: HttpClient) {
		super(httpClient);
	}

	public async getAllAsync(): Promise<Image[]> {
		return []
			.concat(await this.applicationTypeImagesAsync())
			.concat(await  this.technologyCategoryImagesAsync());
	}

	public async getByIdAsync(id: string): Promise<Image> {
		const request: Image[] = await this.getAllAsync();
		for (const image of request) {
			if (image.id === id) {
				return image;
			}
		}
		throw Error("Image.Id not found");
	}

	private async technologyCategoryImagesAsync(): Promise<Image[]> {
		return [
			{
				id: "technology-category/organic-photovoltaics",
				url: "/assets/images/icons/photovoltaics/SolarCells.png",
			},
			{
				id: "technology-category/flexible-displays",
				url: "/assets/images/icons/flexible-electronics/TFT_Automotive.png",

			},
			{
				id: "technology-category/oled-lighting",
				url: "/assets/images/icons/oled-lighting/OLED_stripe.png",

			},
			{
				id: "technology-category/electronics-and-components",
				url: "/assets/images/icons/integrated-smart-systems/OLED_glasses.png",

			},
			{
				id: "technology-category/integrated-smart-systems",
				url: "/assets/images/icons/integrated-smart-systems/Wereables_2.png",

			},
		];
	}

	private async applicationTypeImagesAsync(): Promise<Image[]> {
		return [
			{
				id: "application-type/automotive",
				url: "/assets/images/icons/application-type/automotive.svg",
			},
			{
				id: "application-type/building",
				url: "/assets/images/icons/application-type/building.svg",
			},
			{
				id: "application-type/electronics",
				url: "/assets/images/icons/application-type/electronics.svg",
			},
			{
				id: "application-type/energy",
				url: "/assets/images/icons/application-type/energy.svg",
			},
			{
				id: "application-type/light",
				url: "/assets/images/icons/application-type/light.svg",
			},
			{
				id: "application-type/logistics",
				url: "/assets/images/icons/application-type/logistics.svg",
			},
			{
				id: "application-type/medical",
				url: "/assets/images/icons/application-type/medical.svg",
			},
			{
				id: "application-type/packaging",
				url: "/assets/images/icons/application-type/packaging.svg",
			},
			{
				id: "application-type/printing",
				url: "/assets/images/icons/application-type/printing.svg",
			},
			{
				id: "application-type/textiles",
				url: "/assets/images/icons/application-type/textiles.svg",
			},
			{
				id: "application-type/other",
				url: "/assets/images/icons/application-type/other.svg",
			},
		];
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/services/ImageService.ts